import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import { Provider } from 'react-redux'
import { store } from './store/root'

const widgets = document.querySelectorAll('.tukios_subscribe')

widgets.forEach(Div => {
    ReactDOM.render(
        <React.StrictMode>
            <Provider store={store}>
                <App data={Div} />
            </Provider>
        </React.StrictMode>,
        Div
    )
})